export const szcecinLower ='szczecin'
export const szczecinUpper ='Szczecin'
export const pilaLower ='piła'
export const pilaUpper ='Piła'
export const phoneSzczecin = '+48512652213';
export const phonePila = '+48731842951';
export const emailPila = 'zlobek.rudolf.pila@gmail.com';
export const emailSzczecin = 'zlobek.rudolf@gmail.com';
export const FBLinkSzczecin =
  'https://www.facebook.com/pg/prywatnyZlobekRudolfPomorzanySzczecin'
export const FBLinkPila = 'https://www.facebook.com/prywatnyZlobekRudolfPila'